import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
// import { combineReducers, AnyAction } from 'redux';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, TypedUseSelectorHook } from 'react-redux';
import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './my_pages/auth';
import summaryReducer from './my_pages/summary';
import subdomainsReducer from './my_pages/subdomains';
import portsReducer from './my_pages/ports';
import targetsReducer from './my_pages/targets';
import appGeneralReducer from './my_pages/app';
import notificationPreferencesReducer from './my_pages/notificationPreferences';

// Combine all reducers
const appReducer = combineReducers({
  customizer: CustomizerReducer,
  authReducer,
  appGeneralReducer,
  summaryReducer,
  targetsReducer,
  subdomainsReducer,
  portsReducer,
  notificationPreferencesReducer,
});

// Root reducer with reset functionality
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any ) => {
  if (action.type === 'CLEARALL') {
    state = appReducer(undefined, action); // Reset states
  }
  return appReducer(state, action);
};

// Configure store
export const store = configureStore({
  reducer: rootReducer,
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const { dispatch } = store;
export const useDispatch = () => useAppDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;

export default store;
